import React from 'react';
import { useTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';

const baseStyles = {
   fontFamily: 'Inter',
   fontWeight: 400,
   textTransform: 'none',
   borderRadius: '6px',
   padding: '10px 16px',
   paddingInline: '56px',
   gap: '8px',
   lineHeight: '1.2',
   letterSpacing: '0%',
   boxShadow: 'none',
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center',
   whiteSpace: 'nowrap',
   '& .MuiButton-startIcon': {
      marginRight: 0,
   },
};

const baseDisabledStyles = {
   opacity: 0.4,
   boxShadow: 'none',
};

export default function CustomButton({
   variant = 'primary',
   children,
   startIcon,
   endIcon,
   sx = {},
   ...props
}) {

   const variantConfig = {
      primary: {
         backgroundColor: '#5DB55D',
         color: '#292C2F',
         '&:hover': {
            backgroundColor: "#4FA44F",
         },
         '&:disabled': {
            backgroundColor: "#BBF7D0",
            color: '#6B7280',
            ...baseDisabledStyles,
         },
      },

      outlined: {
         backgroundColor: '#FFFFFF',
         color: "#292C2F",
         border: '2px solid #003F2E',
         '&:hover': {
            backgroundColor: '#FFFFFF',
         },
         '&:disabled': {
            backgroundColor: '#FFFFFF',
            color: "#292C2F",
            ...baseDisabledStyles,
         },
      },

      secondary: {
         backgroundColor: '#FFFFFF',
         color: "#292C2F",
         fontSize: '12px',
         boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.25)',
         '&:hover': {
            backgroundColor: '#F5F5F5',
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
         },
         '&:disabled': {
            backgroundColor: '#FFFFFF',
            color: "#292C2F",
            ...baseDisabledStyles,
         },
      },

      tertiary: {
         backgroundColor: '#F7F8F8',
         color: "#292C2F",
         border: '1px solid #E3E7EC',
         '&:hover': {
            backgroundColor: '#EEEFF0',
         },
         '&:disabled': {
            backgroundColor: '#F7F8F8',
            color: '#FFFFFF',
            ...baseDisabledStyles,
         },
      },

      muted: {
         backgroundColor: '#C3D7C3',
         color: "#292C2F",
         border: '1px solid #E3E7EC',
         height: '48px',
         padding: '10px 24px',
         '&:hover': {
            backgroundColor: '#B4C8B4',
         },
         '&:disabled': {
            backgroundColor: '#C3D7C3',
            color: '#292C2F',
            ...baseDisabledStyles,
         },
      },

      neutral: {
         backgroundColor: '#F7F8F8',
         color: "#292C2F",
         border: '1px solid #E3E7EC',
         padding: '10px 56px',
         '&:hover': {
            backgroundColor: '#EEEFF0',
         },
         '&:disabled': {
            backgroundColor: '#F7F8F8',
            color: '#292C2F',
            ...baseDisabledStyles,
         },
      },

      dark: {
         backgroundColor: '#003022',
         color: '#FFFFFF',
         '&:hover': {
            backgroundColor: '#004532',
         },
         '&:disabled': {
            backgroundColor: '#003022',
            color: '#FFFFFF',
            ...baseDisabledStyles,
         },
      },

      notApproved: {
         backgroundColor: '#B6174B',
         color: '#FFFFFF',
         '&:hover': {
            backgroundColor: '#9E1240',
         },
         '&:disabled': {
            backgroundColor: '#B6174B',
            color: '#FFFFFF',
            ...baseDisabledStyles,
         },
      },

      approved: {
         backgroundColor: '#1D641D',
         color: '#FFFFFF',
         '&:hover': {
            backgroundColor: '#175217',
         },
         '&:disabled': {
            backgroundColor: '#1D641D',
            color: '#FFFFFF',
            ...baseDisabledStyles,
         },
      },
   };
   const currentVariant = variantConfig[variant] ?? variantConfig.primary;

   return (
      <Button
         startIcon={startIcon}
         endIcon={endIcon}
         sx={{
            ...baseStyles,
            ...currentVariant,
            ...sx,
         }}
         {...props}
      >
         {children}
      </Button>
   );
}